/* EC75 Shopify external runtime — generated from v38; Shopify compatibility fix v38.7. */
(()=>{
  const EC75_SCOPE=()=>document.getElementById('ec75-detail')||document;
  const EC75_FILE=(name)=>{
    const root=document.getElementById('ec75-detail');
    if(!root)return '';
    return root.getAttribute('data-ec75-file-'+name)||'';
  };

  // v38.4: keep EC75 inside the Custom Liquid section.
  // v38.3 moved #ec75-detail to document.body to protect sticky motion, which made
  // Shopify Theme Editor show an empty Custom Liquid section and could relocate
  // the detail page away from its intended position. Instead, keep the root in
  // place and only release overflow/contain on the local Custom Liquid wrappers.
  const EC75_RELEASE_LOCAL_WRAPPERS=()=>{
    const root=document.getElementById('ec75-detail');
    if(!root||root.dataset.ec75WrappersReleased==='4')return root;
    let p=root.parentElement;
    let hops=0;
    while(p&&p!==document.body&&hops<6){
      const isShopifySection=p.classList&&p.classList.contains('shopify-section');
      const isLikelyWrapper=isShopifySection||/custom|liquid|section|page-width/i.test(String(p.className||''));
      if(isLikelyWrapper){
        p.style.setProperty('overflow','visible','important');
        p.style.setProperty('overflow-x','visible','important');
        p.style.setProperty('overflow-y','visible','important');
        p.style.setProperty('contain','none','important');
      }
      if(isShopifySection)break;
      p=p.parentElement;
      hops++;
    }
    root.dataset.ec75WrappersReleased='4';
    return root;
  };
  EC75_RELEASE_LOCAL_WRAPPERS();

  // Make a Custom Liquid block visually full-bleed even when the theme nests it in a product-info column.
  const EC75_ALIGN_FULL_BLEED=()=>{
    const root=document.getElementById('ec75-detail');
    if(!root)return;
    // CSS handles the normal breakout. The measured correction is only a fallback
    // for themes whose Custom Liquid wrapper is not symmetrically centered.
    root.style.removeProperty('margin-left');
    root.style.removeProperty('width');
    requestAnimationFrame(()=>{
      const left=root.getBoundingClientRect().left;
      const vw=window.innerWidth||document.documentElement.clientWidth||0;
      if(vw>0&&Math.abs(left)>1){
        root.style.setProperty('--ec75-measured-left',left+'px');
      }else{
        root.style.removeProperty('--ec75-measured-left');
      }
    });
  };
  const EC75_ALIGN_REQUEST=()=>requestAnimationFrame(EC75_ALIGN_FULL_BLEED);
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',EC75_ALIGN_REQUEST,{once:true});else EC75_ALIGN_REQUEST();
  window.addEventListener('resize',EC75_ALIGN_REQUEST,{passive:true});
  window.addEventListener('pageshow',EC75_ALIGN_REQUEST);
  document.addEventListener('shopify:section:load',EC75_ALIGN_REQUEST);

;
/* ===== Original inline script 1 ===== */
(()=>{const button=EC75_SCOPE().querySelector('.shadowblade-sound-intro__toggle');if(!button)return;const apply=(enabled)=>{button.dataset.enabled=String(enabled);button.setAttribute('aria-pressed',String(enabled));button.setAttribute('aria-label',enabled?'Mute sound':'Enable sound');EC75_SCOPE().querySelectorAll('[data-shadowblade-sound]').forEach((media)=>{media.muted=!enabled;if(enabled&&typeof media.play==='function')media.play().catch(()=>{});});window.dispatchEvent(new CustomEvent('shadowblade:soundchange',{detail:{enabled}}));};apply(false);button.addEventListener('click',()=>apply(button.dataset.enabled!=='true'));})();


;
/* ===== Original inline script 2 ===== */
window.addEventListener('DOMContentLoaded',()=>{
  EC75_SCOPE().querySelectorAll('video').forEach(v=>{
    v.muted=true;
    const p=v.play();
    if(p&&typeof p.catch==='function') p.catch(()=>{});
  });
});


;
/* ===== Original inline script 3 ===== */
(function(){
  function initPerformanceFocus(root){
    if(!root || root.dataset.focusReady==='1') return;
    root.dataset.focusReady='1';
    var finePointer=window.matchMedia?window.matchMedia('(pointer:fine)'):null;
    root.querySelectorAll('[data-focus-card]').forEach(function(card){
      var sharpLayer=card.querySelector('.sharp-layer');
      var border=card.querySelector('.lens-border');
      if(!sharpLayer||!border) return;
      var hovering=false, raf=0, pending=null;
      function metrics(){var rect=card.getBoundingClientRect();var designW=parseFloat(card.dataset.designWidth)||1;var scale=rect.width/designW;return{rect:rect,scale:scale,lensW:(parseFloat(card.dataset.lensW)||190)*scale,lensH:(parseFloat(card.dataset.lensH)||190)*scale,radius:(parseFloat(card.dataset.radius)||30)*scale};}
      function apply(left,top){var m=metrics();var maxLeft=Math.max(0,m.rect.width-m.lensW),maxTop=Math.max(0,m.rect.height-m.lensH);left=Math.max(0,Math.min(maxLeft,left));top=Math.max(0,Math.min(maxTop,top));var right=Math.max(0,m.rect.width-left-m.lensW),bottom=Math.max(0,m.rect.height-top-m.lensH);border.style.left=left+'px';border.style.top=top+'px';border.style.width=m.lensW+'px';border.style.height=m.lensH+'px';border.style.borderRadius=m.radius+'px';sharpLayer.style.clipPath='inset('+top+'px '+right+'px '+bottom+'px '+left+'px round '+m.radius+'px)';}
      function reset(){var m=metrics();apply((parseFloat(card.dataset.defaultX)||0)*m.scale,(parseFloat(card.dataset.defaultY)||0)*m.scale);}
      function schedule(left,top){pending=[left,top];if(raf)return;raf=requestAnimationFrame(function(){raf=0;if(pending){apply(pending[0],pending[1]);pending=null;}});}
      card.addEventListener('pointerenter',function(e){if(finePointer&&!finePointer.matches)return;if(e.pointerType&&e.pointerType!=='mouse'&&e.pointerType!=='pen')return;hovering=true;card.classList.add('is-tracking');});
      card.addEventListener('pointermove',function(e){if(finePointer&&!finePointer.matches)return;if(e.pointerType&&e.pointerType!=='mouse'&&e.pointerType!=='pen')return;var m=metrics();hovering=true;card.classList.add('is-tracking');schedule(e.clientX-m.rect.left-m.lensW/2,e.clientY-m.rect.top-m.lensH/2);},{passive:true});
      card.addEventListener('pointerleave',function(){hovering=false;card.classList.remove('is-tracking');reset();});
      window.addEventListener('resize',function(){if(!hovering)reset();},{passive:true});
      requestAnimationFrame(reset);
    });
  }
  initPerformanceFocus(document.getElementById('ShadowbladePerformance-preview'));
  document.addEventListener('shopify:section:load',function(e){if(e.target&&e.target.querySelector){var next=e.target.querySelector('[id^="ShadowbladePerformance-"]');if(next)initPerformanceFocus(next);}});
})();


;
/* ===== Original inline script 4 ===== */
(function(){
  function clamp(v,a,b){return Math.max(a,Math.min(b,v));}
  function norm(v,a,b){return clamp((v-a)/(b-a),0,1);}
  function smooth(t){return t*t*(3-2*t);}
  function lerp(a,b,t){return a+(b-a)*t;}
  function init(root){
    if(!root||root.dataset.sb9v9V6==='1') return;root.dataset.sb9v9V6='1';
    var runway=root.querySelector('[data-sb9v9-runway]'),pin=root.querySelector('[data-sb9v9-pin]');if(!runway||!pin)return;
    var raf=0,keyRaf=0,manualStage=null,currentManual=0;
    function editable(t){return !!(t&&t.closest&&t.closest('input,textarea,select,[contenteditable="true"]'))}
    function centered(){var r=root.getBoundingClientRect(),vh=window.innerHeight||document.documentElement.clientHeight||1;return r.top<=vh*.62&&r.bottom>=vh*.38}
    function scrollRaw(){var rr=runway.getBoundingClientRect(),ph=pin.getBoundingClientRect().height,distance=Math.max(1,rr.height-ph);return clamp((-rr.top)/distance,0,1)}
    function render(raw){
      var scrollExplode=smooth(norm(raw,.30,.58)),explode=manualStage===null?scrollExplode:currentManual,titleOut=smooth(norm(raw,.36,.56)),eyebrowOut=smooth(norm(raw,.48,.66)),after=smooth(norm(raw,.64,.97)),explosionExit=smooth(norm(raw,.66,.86)),bandY=lerp(590,92,after),lowerOpacity=smooth(norm(raw,.72,.88));
      root.style.setProperty('--raw',raw.toFixed(4));root.style.setProperty('--explode',explode.toFixed(4));root.style.setProperty('--parts-opacity',clamp(explode*5,0,1).toFixed(4));root.style.setProperty('--band-y',bandY.toFixed(2));root.style.setProperty('--lower-opacity',lowerOpacity.toFixed(4));root.style.setProperty('--explode-shift',(-570*explosionExit).toFixed(2));root.style.setProperty('--title-shift',(-205*titleOut).toFixed(2));root.style.setProperty('--title-opacity',(1-titleOut).toFixed(4));root.style.setProperty('--eyebrow-shift',(-80*eyebrowOut).toFixed(2));root.style.setProperty('--eyebrow-opacity',(1-eyebrowOut).toFixed(4));
    }
    function update(){raf=0;render(scrollRaw())}function schedule(){if(!raf)raf=requestAnimationFrame(update)}
    function setStage(next){next=Math.max(0,Math.min(4,next));var from=currentManual,to=next/4;manualStage=next;cancelAnimationFrame(keyRaf);var start=performance.now(),dur=300;function tick(now){var p=Math.min(1,(now-start)/dur),q=1-Math.pow(1-p,3);currentManual=from+(to-from)*q;render(scrollRaw());if(p<1)keyRaf=requestAnimationFrame(tick)}keyRaf=requestAnimationFrame(tick)}
    window.addEventListener('keydown',function(e){if(editable(e.target)||!centered())return;if(e.code==='KeyS'){var base=manualStage===null?Math.round(smooth(norm(scrollRaw(),.30,.58))*4):manualStage;setStage(base+1)}else if(e.code==='KeyW'){var base=manualStage===null?Math.round(smooth(norm(scrollRaw(),.30,.58))*4):manualStage;setStage(base-1)}});
    window.addEventListener('scroll',schedule,{passive:true});window.addEventListener('resize',schedule,{passive:true});
    if('IntersectionObserver'in window){var io=new IntersectionObserver(function(es){es.forEach(function(e){if(!e.isIntersecting){manualStage=null;currentManual=0}})},{threshold:[0,.05]});io.observe(root)}
    requestAnimationFrame(update);
  }
  init(document.getElementById('ShadowbladeSwitchPro-preview'));
  document.addEventListener('shopify:section:load',function(e){if(e.target&&e.target.querySelector){var r=e.target.querySelector('[id^="ShadowbladeSwitchPro-"]');if(r)init(r);}});
})();


;
/* ===== Original inline script 5 ===== */
(function(){function init(root){if(!root||root.dataset.hypercoreObserverReady==='1')return;root.dataset.hypercoreObserverReady='1';root.setAttribute('data-reveal-ready','1');var timer=0;function reveal(){clearTimeout(timer);timer=setTimeout(function(){requestAnimationFrame(function(){requestAnimationFrame(function(){root.classList.add('is-revealed')})})},180)}function reset(){clearTimeout(timer);root.classList.remove('is-revealed')}if('IntersectionObserver' in window){var io=new IntersectionObserver(function(entries){entries.forEach(function(entry){if(entry.isIntersecting&&entry.intersectionRatio>=.08)reveal();else if(!entry.isIntersecting)reset()})},{threshold:[0,.08,.2,.5],rootMargin:'0px 0px -8% 0px'});io.observe(root)}else{reveal()}}init(document.getElementById('ShadowbladeHyperCore-preview'))})();


;
/* ===== Original inline script 6 ===== */
EC75_SCOPE().querySelectorAll('.card').forEach(c=>{c.addEventListener('click',()=>{const a=c.classList.contains('active');EC75_SCOPE().querySelectorAll('.card').forEach(x=>x.classList.remove('active'));if(!a)c.classList.add('active')})})


;
/* ===== Original inline script 7 ===== */
(function(){
  function el(cls,html){const n=document.createElement('span');n.className=cls;if(html!=null)n.textContent=html;return n}
  const cards=[...EC75_SCOPE().querySelectorAll('.card')];
  cards.forEach(card=>{
    card.appendChild(el('sb12-glow'));
    if(card.classList.contains('actuation')){
      card.appendChild(el('sb12-act-mask'));card.appendChild(el('sb12-act-fill'));card.appendChild(el('sb12-act-handle'));card.appendChild(el('sb12-act-pointer'));card.appendChild(el('sb12-act-label','1.50mm'));
    }
    if(card.classList.contains('switch')||card.classList.contains('logic')||card.classList.contains('light')){
      const base=card.querySelector('img'); if(base){const dup=base.cloneNode(true);dup.removeAttribute('alt');dup.className='sb12-active-copy';card.appendChild(dup)}
    }
    if(card.classList.contains('switch')) card.appendChild(el('sb12-switch-outline'));
    if(card.classList.contains('logic')) card.appendChild(el('sb12-logic-outline'));
    if(card.classList.contains('light')){
      card.appendChild(el('sb12-light-glass'));
      const bar=el('sb12-light-huebar');bar.appendChild(document.createElement('i'));card.appendChild(bar);
      card.appendChild(el('sb12-light-swatch'));
    }
    if(card.classList.contains('rapid')){
      card.appendChild(el('sb12-rapid-track sb12-rapid-track--press'));card.appendChild(el('sb12-rapid-track sb12-rapid-track--release'));card.appendChild(el('sb12-rapid-track sb12-rapid-track--bottom'));
      const t1=el('sb12-toggle sb12-toggle--top');t1.appendChild(document.createElement('i'));card.appendChild(t1);
      const t2=el('sb12-toggle sb12-toggle--bottom');t2.appendChild(document.createElement('i'));card.appendChild(t2);
    }
  });
  const target=(location.hash||'').replace('#','');if(target){const c=EC75_SCOPE().querySelector('.'+target);if(c)c.classList.add('active')}
})();


;
/* ===== Original inline script 8 ===== */
(function(){const m={"adjustable": EC75_FILE("ec75-v38-s12-hover-exact-adjustable.png"), "profiles": EC75_FILE("ec75-v38-s12-hover-exact-profiles.png"), "switch": EC75_FILE("ec75-v38-s12-hover-exact-switch.png"), "logic": EC75_FILE("ec75-v38-s12-hover-exact-logic.png"), "light": EC75_FILE("ec75-v38-s12-hover-exact-light.png"), "rapid": EC75_FILE("ec75-v38-s12-hover-exact-rapid.png")};Object.entries(m).forEach(([k,src])=>{const c=EC75_SCOPE().querySelector("."+k);if(!c)return;const i=document.createElement("img");i.className="sb12-exact-hover";i.src=src;i.alt="";i.setAttribute("aria-hidden","true");c.appendChild(i);});})();


;
/* ===== Original inline script 9 ===== */
(function(){
  var root=document.getElementById('section12'); if(!root||root.dataset.v11==='1')return; root.dataset.v11='1';
  var srcs={'switch':EC75_FILE("ec75-v38-s12-hover-v11-switch.png"),'logic':EC75_FILE("ec75-v38-s12-hover-v11-logic.png"),'light':EC75_FILE("ec75-v38-s12-hover-v11-light.png"),'rapid':EC75_FILE("ec75-v38-s12-hover-v11-rapid.png")};
  ['switch','logic','light','rapid'].forEach(function(k){
    var c=root.querySelector('.'+k); if(!c)return;
    var first=c.querySelector(':scope > img:not(.sb12-exact-hover)');
    if(first) first.classList.add('v11-default');
    var im=document.createElement('img'); im.className='v11-hover'; im.src=srcs[k]; im.alt=''; im.setAttribute('aria-hidden','true'); c.appendChild(im);
  });
})();


;
/* ===== Original inline script 10 ===== */
(function(){
 const root=EC75_SCOPE().querySelector('[data-sb13]'); if(!root)return;
 const videos=[...root.querySelectorAll('[data-sb13-video]')]; if(!videos.length)return;
 let active=false,syncTimer=0;
 function hardSync(){
  const t=videos[0].currentTime||0;
  videos.slice(1).forEach(v=>{ if(Number.isFinite(v.duration)&&Math.abs(v.currentTime-t)>.055) v.currentTime=t; });
 }
 function playAll(){
  if(active)return; active=true;
  videos.forEach(v=>{v.muted=true;v.playbackRate=1;v.currentTime=0;});
  Promise.allSettled(videos.map(v=>v.play())).then(()=>hardSync());
  syncTimer=window.setInterval(hardSync,1200);
 }
 function pauseAll(){
  active=false; if(syncTimer){clearInterval(syncTimer);syncTimer=0;}
  videos.forEach(v=>v.pause());
 }
 if('IntersectionObserver' in window){
  const io=new IntersectionObserver(es=>es.forEach(e=>e.isIntersecting?playAll():pauseAll()),{threshold:.08});io.observe(root);
 } else playAll();
})();


;
/* ===== Original inline script 11 ===== */
(function(){
function init(root){
 if(!root||root.dataset.sb14Ready==='1')return;
 root.dataset.sb14Ready='1';
 var enabled=root.dataset.motion!=='false',played=false,animating=false,welcome=root.querySelector('.sb14__welcome-wrap'),raf=0;
 if(!welcome)return;
 function stop(){root.classList.remove('is-welcome-floating');animating=false}
 function visible(){var r=root.getBoundingClientRect(),vh=window.innerHeight||document.documentElement.clientHeight||0;var vis=Math.min(r.bottom,vh)-Math.max(r.top,0);var need=Math.min(r.height*.12,vh*.25);return vis>Math.max(90,need)}
 function play(){if(!enabled||played||animating||!visible())return;played=true;animating=true;root.classList.remove('is-welcome-floating');void welcome.offsetWidth;root.classList.add('is-welcome-floating')}
 function sync(fromInput){if(!visible()){played=false;stop();return}if(fromInput)play()}
 function trigger(){if(raf)return;raf=requestAnimationFrame(function(){raf=0;sync(true)})}
 welcome.addEventListener('animationend',stop);
 window.addEventListener('wheel',trigger,{passive:true});
 window.addEventListener('scroll',trigger,{passive:true});
 window.addEventListener('touchmove',trigger,{passive:true});
 window.addEventListener('keydown',function(e){if(['ArrowDown','ArrowUp','PageDown','PageUp','Space','Home','End'].indexOf(e.code)>=0)trigger()});
 window.addEventListener('resize',function(){sync(false)},{passive:true});
}
function boot(){EC75_SCOPE().querySelectorAll('[data-sb14]').forEach(init)}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',boot,{once:true});else boot();
window.addEventListener('pageshow',boot);
document.addEventListener('shopify:section:load',function(e){var r=e.target&&e.target.querySelector&&e.target.querySelector('[data-sb14]');if(r){r.dataset.sb14Ready='';init(r)}});
})();


;
/* ===== Original inline script 12 / FIX15 Section 16 audio ===== */
(function(){
  function scope(){return EC75_SCOPE();}
  function initVideo(video){
    if(!video || video.dataset.sb16SoundReady==='1') return;
    video.dataset.sb16SoundReady='1';
    var soundEnabled=false;
    var active=false;
    var io=null;

    function readGlobalSound(){
      var button=scope().querySelector('.shadowblade-sound-intro__toggle');
      return !!(button && button.dataset.enabled==='true');
    }
    function ensurePlay(){
      var p=video.play();
      if(p && typeof p.catch==='function') p.catch(function(){});
    }
    function sync(){
      var audible=!!(soundEnabled && active && !document.hidden);
      video.muted=!audible;
      video.defaultMuted=true;
      if(audible) video.volume=1;
      ensurePlay();
    }
    function setActive(next){
      active=!!next;
      sync();
    }
    function setSound(next){
      soundEnabled=!!next;
      sync();
    }

    /* Preserve autoplay policy: start muted, then only unmute after the page-wide
       sound button has been enabled and Section 16 is actually on screen. */
    soundEnabled=readGlobalSound();
    video.muted=true;
    video.defaultMuted=true;
    ensurePlay();

    window.addEventListener('shadowblade:soundchange',function(e){
      setSound(!!(e.detail && e.detail.enabled));
    });

    if('IntersectionObserver' in window){
      io=new IntersectionObserver(function(entries){
        entries.forEach(function(entry){
          setActive(!!(entry.isIntersecting && entry.intersectionRatio>0.10));
        });
      },{threshold:[0,0.10,0.25,0.5]});
      io.observe(video.closest('[data-sb16]') || video);
    }else{
      setActive(true);
    }

    document.addEventListener('visibilitychange',function(){
      if(!document.hidden) soundEnabled=readGlobalSound();
      sync();
    });
    window.addEventListener('pageshow',function(){
      soundEnabled=readGlobalSound();
      sync();
    });
  }
  function startSB16(root){
    (root||scope()).querySelectorAll('[data-sb16-video]').forEach(initVideo);
  }
  if(document.readyState==='loading'){
    document.addEventListener('DOMContentLoaded',function(){startSB16(scope());},{once:true});
  }else{
    startSB16(scope());
  }
  document.addEventListener('shopify:section:load',function(e){
    var target=e.target;
    if(target && target.querySelectorAll) target.querySelectorAll('[data-sb16-video]').forEach(initVideo);
  });
})();


;
/* ===== Original inline script 13 ===== */
(function(){
  var STATES={"2560":{"title":"BUILT ON A SOLID FOUNDATION","desc":"A CNC-machined aluminum plate keeps every switch firmly supported, reducing unwanted movement and key wobble for a more stable, consistent feel across the board.","titleGeom":[613.296875,150,1331.9296875,220],"descGeom":[851.38671875,398,852.2421875,84],"cards":{"2561":[93.94140625,1403.26171875,469.3863830566406,626.4608764648438,60],"2557":[2231.8359375,996.76171875,470,627,-60],"2559":[1703.62890625,643.30078125,469.3863830566406,626.4608764648438,-30],"2558":[449.87109375,878.22265625,470.3049621582031,626.4608764648438,30],"2560":[1045.0078125,602.76171875,469.3863830566406,626.4608764648438,0]}},"2561":{"title":"PREMIUM WHERE IT MATTERS","desc":"A CNC-machined aluminum top brings the solid, premium feel of metal, while the lightweight PC base keeps EC75 practical for everyday use.","titleGeom":[829.1814575195312,150,901.15625,220],"descGeom":[860.9314575195312,400,832.78515625,56],"cards":{"2560":[2231.4296875,996.96875,469.3863830566406,626.4608764648438,-60],"2557":[2380.16796875,2181.216796875,470,627,-120],"2558":[1703.6875,643.5078125,470.3049621582031,626.4608764648438,-30],"2561":[1045.06640625,602.96875,469.3863830566406,626.4608764648438,0],"2559":[2422.16796875,1547.041015625,469.3863830566406,626.4608764648438,-90]}},"2558":{"title":"LIGHT IT YOUR WAY","desc":"Bright, even RGB brings every key to life with smooth transitions and vivid color. Keep it subtle or make it stand out—the look is yours to shape.","titleGeom":[800.28515625,229.15234375,959.427734375,110],"descGeom":[883.54296875,369.15234375,792.9140625,84],"cards":{"2561":[449.92578125,878.677734375,469.3863830566406,626.4608764648438,30],"2557":[2464.6875,1569.9296875,470,627,-90],"2559":[2231.4296875,997.673828125,469.3863830566406,626.4608764648438,-60],"2560":[1703.6875,644.212890625,469.3863830566406,626.4608764648438,-30],"2558":[1045.0703125,603.673828125,470.3049621582031,626.4608764648438,0]}},"2557":{"title":"SWAP.CALIBRATE.PLAY.","desc":"Swap in compatible magnetic switches and EC75 automatically recognizes and calibrates them for stable actuation and consistent response. More freedom to experiment, less time spent recalibrating.","titleGeom":[697.9365234375,211.3040008544922,1164.126953125,110],"descGeom":[884.5546875,351.3039855957031,790.892578125,84],"cards":{"2561":[415.1484375,2588.501953125,469.3863830566406,626.4608764648438,120],"2560":[93.8828125,1403.990234375,469.3863830566406,626.4608764648438,60],"2559":[449.81640625,878.494140625,469.3863830566406,626.4608764648438,30],"2558":[138.41796875,2017.736328125,470.3049621582031,626.4608764648438,90],"2557":[1044.95703125,603.490234375,470,627,0]}},"2559":{"title":"DESIGNED TO STAND APART","desc":"A layered geometric accent adds depth and character to EC75, with a violet textured finish that shifts subtly as the light moves.","titleGeom":[937.7520751953125,165.0830078125,684.49609375,220],"descGeom":[935.2589111328125,415.0830078125,689.482421875,84],"cards":{"2561":[95.78515625,2039.060546875,469.3863830566406,626.4608764648438,90],"2558":[93.84765625,1404.560546875,470.3049621582031,626.4608764648438,60],"2557":[1703.8046875,643.802734375,470,627,-30],"2560":[449.7734375,878.267578125,469.3863830566406,626.4608764648438,30],"2559":[1044.91796875,603.263671875,469.3863830566406,626.4608764648438,0]}}};
  function init(root){
    if(!root || root.dataset.sb17Ready==='1') return;
    root.dataset.sb17Ready='1';
    var titles=Array.prototype.slice.call(root.querySelectorAll('[data-sb17-title]'));
    var descs=Array.prototype.slice.call(root.querySelectorAll('[data-sb17-desc]'));
    var cards=Array.prototype.slice.call(root.querySelectorAll('[data-sb17-card]'));
    var active='2560';
    var textSlot=0;
    var cleanupTimer=0;
    var unlockTimer=0;
    var motionLocked=false;
    function px(v){return 'calc('+v+' * var(--sb17-u))';}
    function zFor(g,id){ if(id===active) return 40; var r=Math.abs(g[4]); if(r<31)return 30;if(r<61)return 20;return 10; }
    function setGeom(el,g){el.style.left=px(g[0]);el.style.top=px(g[1]);el.style.width=px(g[2]);el.style.height=px(g[3]);}
    function prepareSlot(i,state){
      titles[i].textContent=state.title;
      descs[i].textContent=state.desc;
      setGeom(titles[i],state.titleGeom);
      setGeom(descs[i],state.descGeom);
    }
    function setText(state,instant){
      clearTimeout(cleanupTimer);
      var from=textSlot,to=1-textSlot;
      if(instant){
        prepareSlot(from,state);
        titles[from].style.opacity='1';descs[from].style.opacity='1';
        titles[from].style.transform='translateY(0)';descs[from].style.transform='translateY(0)';
        titles[from].style.visibility='visible';descs[from].style.visibility='visible';
        titles[from].setAttribute('aria-hidden','false');descs[from].setAttribute('aria-hidden','false');
        titles[to].style.opacity='0';descs[to].style.opacity='0';
        titles[to].style.visibility='hidden';descs[to].style.visibility='hidden';
        titles[to].setAttribute('aria-hidden','true');descs[to].setAttribute('aria-hidden','true');
        return;
      }
      var outT=titles[from],outD=descs[from],inT=titles[to],inD=descs[to];
      prepareSlot(to,state);
      [inT,inD].forEach(function(el){el.style.transition='none';el.style.visibility='visible';el.style.opacity='0';el.style.transform='translateY(calc(8 * var(--sb17-u)))';el.setAttribute('aria-hidden','false');});
      void inT.offsetWidth;
      outT.style.transition='opacity .3s ease-out,transform .3s ease-out';
      outD.style.transition='opacity .3s ease-out,transform .3s ease-out';
      inT.style.transition='opacity .3s ease-out,transform .3s ease-out';
      inD.style.transition='opacity .3s ease-out,transform .3s ease-out';
      requestAnimationFrame(function(){
        outT.style.opacity='0';outD.style.opacity='0';
        outT.style.transform='translateY(calc(-5 * var(--sb17-u)))';outD.style.transform='translateY(calc(-4 * var(--sb17-u)))';
        inT.style.opacity='1';inD.style.opacity='1';
        inT.style.transform='translateY(0)';inD.style.transform='translateY(0)';
      });
      textSlot=to;
      cleanupTimer=setTimeout(function(){
        outT.style.visibility='hidden';outD.style.visibility='hidden';
        outT.setAttribute('aria-hidden','true');outD.setAttribute('aria-hidden','true');
        outT.style.transition='';outD.style.transition='';inT.style.transition='';inD.style.transition='';
      },330);
    }
    function apply(next,instant){
      if(!STATES[next] || (!instant && motionLocked)) return;
      active=String(next);root.dataset.active=active;
      var state=STATES[active];
      if(!instant){motionLocked=true;clearTimeout(unlockTimer);unlockTimer=setTimeout(function(){motionLocked=false;},310);}
      cards.forEach(function(card){
        var id=card.getAttribute('data-sb17-card'),g=state.cards[id]; if(!g)return;
        if(instant)card.style.transition='none';
        card.style.left=px(g[0]);card.style.top=px(g[1]);card.style.width=px(g[2]);card.style.height=px(g[3]);
        card.style.transform='rotate('+(-g[4])+'deg)';card.style.zIndex=String(zFor(g,id));
        card.classList.toggle('is-active',id===active);card.setAttribute('aria-pressed',id===active?'true':'false');
        if(instant)requestAnimationFrame(function(){card.style.transition='';});
      });
      setText(state,instant);
    }
    cards.forEach(function(card){
      var id=card.getAttribute('data-sb17-card');
      card.addEventListener('click',function(){card.removeAttribute('data-hover-return');if(id!==active)apply(id,false);});
      if(id==='2561'){
        card.addEventListener('pointerenter',function(e){if(e.pointerType==='touch'||id===active)return;card.setAttribute('data-hover-return',active);if(!motionLocked)apply(id,false);});
        card.addEventListener('pointerleave',function(){var back=card.getAttribute('data-hover-return');card.removeAttribute('data-hover-return');if(!back)return;var restore=function(){if(active!==id)return;if(motionLocked){setTimeout(restore,40);return}apply(back,false)};restore();});
      }
    });
    apply(active,true);
  }
  function initAll(){EC75_SCOPE().querySelectorAll('[data-sb17]').forEach(init);}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',initAll,{once:true});else initAll();
  document.addEventListener('shopify:section:load',function(e){if(e.target&&e.target.querySelectorAll)e.target.querySelectorAll('[data-sb17]').forEach(init);});
})();


;
/* ===== Original inline script 15 ===== */
(function(){
  const root=EC75_SCOPE().querySelector('[data-section18]');
  if(!root)return;

  const reduce=matchMedia('(prefers-reduced-motion: reduce)');
  const clamp=(v,a=0,b=1)=>Math.max(a,Math.min(b,v));
  const lerp=(a,b,t)=>a+(b-a)*t;

  /* Exact layer positions from the four approved Section18 visual states:
     p=0 exploded, then two intermediate states, p=1 assembled. */
  const frames=[
    {p:0,    v:{a581:248.113,a583:361.330,a582:483.408,a584:584.861,a585:706.930,a587:814.250,a589:919.545,a590:1017.176,a591:1124.045,corner1:179.996,corner2:214.906,corner3:247.551,c3o:1}},
    {p:.38,  v:{a581:248.113,a583:335.484,a582:309.971,a584:330.959,a585:389.502,a587:419.203,a589:461.904,a590:494.066,a591:531.719,corner1:204.996,corner2:231.906,corner3:254.551,c3o:1}},
    {p:.68,  v:{a581:248.113,a583:286.485,a582:265.971,a584:274.960,a585:313.502,a587:329.204,a589:343.903,a590:344.067,a591:352.718,corner1:244.996,corner2:256.906,corner3:268.552,c3o:1}},
    {p:1,    v:{a581:248.113,a583:260.093,a582:251.215,a584:260.549,a585:273.019,a587:278.655,a589:278.627,a590:263.000,a591:258.955,corner1:262.996,corner2:264.906,corner3:266.552,c3o:0}}
  ];
  const selectors={
    a581:'.sb18__a581',a583:'.sb18__a583',a582:'.sb18__a582',a584:'.sb18__a584',a585:'.sb18__a585',
    a587:'.sb18__a587',a589:'.sb18__a589',a590:'.sb18__a590',a591:'.sb18__a591',
    corner1:'.sb18__corner1',corner2:'.sb18__corner2',corner3:'.sb18__corner3'
  };
  const nodes={};
  Object.keys(selectors).forEach(k=>nodes[k]=root.querySelector(selectors[k]));
  const cards=[...root.querySelectorAll('.sb18__card')];
  const connectors=root.querySelector('.sb18__connectors');

  let raf=0,lastP=-1;
  function sample(p){
    let a=frames[0],b=frames[frames.length-1];
    for(let i=0;i<frames.length-1;i++){
      if(p>=frames[i].p&&p<=frames[i+1].p){a=frames[i];b=frames[i+1];break}
    }
    const t=(b.p===a.p)?0:clamp((p-a.p)/(b.p-a.p));
    const v={};
    Object.keys(a.v).forEach(k=>v[k]=lerp(a.v[k],b.v[k],t));
    return v;
  }
  function apply(){
    raf=0;
    const rect=root.getBoundingClientRect();
    const vh=window.innerHeight||document.documentElement.clientHeight||1;
    /* Direction corrected: when the user scrolls DOWN through Section18,
       the keyboard opens from assembled to exploded. Scrolling UP closes it. */
    const startLine=vh*.80;
    const endLine=vh*.18;
    let p=1-clamp((startLine-rect.top)/(startLine-endLine));
    if(reduce.matches)p=p<.5?0:1;
    if(Math.abs(p-lastP)<.0005)return;
    lastP=p;

    const v=sample(p);
    Object.keys(selectors).forEach(k=>{
      if(nodes[k])nodes[k].style.top=`calc(${v[k].toFixed(3)} * var(--u))`;
    });
    if(nodes.corner3)nodes.corner3.style.opacity=String(v.c3o);

    /* Labels/leader lines dissolve during the first part of the wheel gesture,
       matching the reference video while keeping the layer stack unobstructed. */
    const infoOpacity=1-clamp(p/.20);
    cards.forEach(el=>el.style.opacity=String(infoOpacity));
    if(connectors)connectors.style.opacity=String(infoOpacity);

    /* data-stage is retained only for the original z-order rules. Motion itself
       is continuous and comes directly from mouse-wheel/page scroll progress. */
    root.dataset.stage=p<.025?'3':(p<.52?'2':(p<.84?'1':'0'));
    root.style.setProperty('--sb18-scroll-progress',p.toFixed(4));
  }
  function request(){if(!raf)raf=requestAnimationFrame(apply)}
  addEventListener('scroll',request,{passive:true});
  addEventListener('resize',()=>{lastP=-1;request()},{passive:true});
  addEventListener('pageshow',()=>{lastP=-1;request()});
  if(reduce.addEventListener)reduce.addEventListener('change',()=>{lastP=-1;request()});
  request();
})();


;
/* ===== Original inline script 16 ===== */
(function(){
  function init(root){
    if(!root||root.dataset.sb19Ready==='1')return;
    root.dataset.sb19Ready='1';
    var v=root.querySelector('[data-sb19-video]');if(!v)return;
    v.muted=true;v.playsInline=true;
    function playFromStart(){try{v.currentTime=0}catch(e){}var p=v.play();if(p&&p.catch)p.catch(function(){});}
    if('IntersectionObserver'in window){
      var io=new IntersectionObserver(function(entries){entries.forEach(function(e){if(e.isIntersecting&&e.intersectionRatio>.08){playFromStart();}else{v.pause();try{v.currentTime=0}catch(err){}}});},{threshold:[0,.08,.25]});io.observe(root);
    }else{playFromStart();}
  }
  function all(){EC75_SCOPE().querySelectorAll('[data-sb19]').forEach(init)}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',all,{once:true});else all();
  document.addEventListener('shopify:section:load',function(e){if(e.target&&e.target.querySelectorAll)e.target.querySelectorAll('[data-sb19]').forEach(init)});
})();


;
/* ===== Original inline script 17 ===== */
(function(){
  function init(root){
    if(!root||root.dataset.sb20Ready==='1')return;
    root.dataset.sb20Ready='1';
    var video=root.querySelector('[data-sb20-video]');
    var audio=root.querySelector('[data-sb20-audio]');
    var globalToggle=EC75_SCOPE().querySelector('.shadowblade-sound-intro__toggle');
    var soundEnabled=!!(globalToggle&&globalToggle.dataset.enabled==='true');
    var active=false,syncTimer=0,gestureArmed=false;

    if(audio){audio.volume=1;audio.preload='auto';}

    function stopSync(){if(syncTimer){clearInterval(syncTimer);syncTimer=0;}}
    function alignAudio(force){
      if(!audio||!video)return;
      var vt=Number(video.currentTime)||0,at=Number(audio.currentTime)||0;
      if(force||Math.abs(vt-at)>.09){try{audio.currentTime=vt}catch(e){}}
    }
    function playAudio(){
      if(!audio||!video||!active||!soundEnabled)return;
      alignAudio(true);
      var p=audio.play();if(p&&p.catch)p.catch(function(){});
      stopSync();syncTimer=setInterval(function(){if(active&&soundEnabled){alignAudio(false)}},450);
    }
    function pauseAudio(reset){
      stopSync();if(!audio)return;audio.pause();if(reset){try{audio.currentTime=0}catch(e){}}
    }
    function restart(){
      active=true;
      root.classList.remove('is-active');void root.offsetWidth;root.classList.add('is-active');
      if(video){try{video.currentTime=0}catch(e){}var p=video.play();if(p&&p.catch)p.catch(function(){});}
      if(soundEnabled)playAudio();else pauseAudio(true);
    }
    function reset(){
      active=false;root.classList.remove('is-active');
      if(video){video.pause();try{video.currentTime=0}catch(e){}}
      pauseAudio(true);
    }
    function setSound(enabled){
      soundEnabled=!!enabled;
      if(!audio)return;
      if(soundEnabled&&active)playAudio();else pauseAudio(false);
    }

    window.addEventListener('shadowblade:soundchange',function(e){setSound(!!(e.detail&&e.detail.enabled));});

    /* Standalone/section-only fallback: browsers require a user gesture for audible playback.
       When the page-wide sound toggle is absent, the first click/tap/key press enables the supplied Section 20 audio. */
    if(!globalToggle&&!gestureArmed){
      gestureArmed=true;
      var enableOnGesture=function(){setSound(true);document.removeEventListener('pointerdown',enableOnGesture,true);document.removeEventListener('keydown',enableOnGesture,true);};
      document.addEventListener('pointerdown',enableOnGesture,true);
      document.addEventListener('keydown',enableOnGesture,true);
    }

    if(video){
      video.addEventListener('ended',function(){pauseAudio(true);});
      video.addEventListener('seeking',function(){if(soundEnabled&&active)alignAudio(true);});
    }
    if('IntersectionObserver' in window){
      var io=new IntersectionObserver(function(entries){entries.forEach(function(e){if(e.isIntersecting&&e.intersectionRatio>.10)restart();else reset();});},{threshold:[0,.1,.35]});
      io.observe(root);
    }else restart();
  }
  function all(){EC75_SCOPE().querySelectorAll('[data-sb20]').forEach(init)}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',all,{once:true});else all();
  document.addEventListener('shopify:section:load',function(e){if(e.target&&e.target.querySelectorAll)e.target.querySelectorAll('[data-sb20]').forEach(init)});
})();


;
/* ===== Original inline script 18 ===== */
(function(){
 var root=EC75_SCOPE().querySelector('[data-sb21]');if(!root||root.dataset.sb21V9==='1')return;root.dataset.sb21V9='1';
 var video=root.querySelector('video'),buttons=[].slice.call(root.querySelectorAll('.sb21__level')),level=3,seekRaf=0,reduced=window.matchMedia&&window.matchMedia('(prefers-reduced-motion: reduce)').matches,initial=null;
 if(video&&video.poster){initial=document.createElement('img');initial.className='sb21__initial-state';initial.alt='';initial.setAttribute('aria-hidden','true');initial.src=video.poster;video.parentNode.appendChild(initial)}
 function active(l){level=l;buttons.forEach(function(b){var on=b.dataset.level===String(l);b.classList.toggle('is-active',on);b.setAttribute('aria-pressed',on?'true':'false')})}
 /* High-resolution click-demo segment: exact stable states are Level 3=0.02s, Level 2=1.15s, Level 1=2.00s. */
 function timeFor(l){return l===1?2.00:(l===2?1.15:0.02)}
 function showInitial(){if(initial)initial.classList.remove('is-hidden')}
 function hideInitial(){if(initial)initial.classList.add('is-hidden')}
 function seekLevel(l,animate,forcedFrom){l=Math.max(1,Math.min(3,l));var previous=level;active(l);if(!video)return;video.pause();cancelAnimationFrame(seekRaf);var to=timeFor(l),from=Number.isFinite(forcedFrom)?forcedFrom:(isFinite(video.currentTime)?video.currentTime:to);if(previous===l&&animate)return;if(!animate||reduced||Math.abs(to-from)<.002){try{video.currentTime=to}catch(e){}return}var start=performance.now(),dur=430;function tick(now){var p=Math.min(1,(now-start)/dur);var q=p*p*(3-2*p);try{video.currentTime=from+(to-from)*q}catch(e){}if(p<1)seekRaf=requestAnimationFrame(tick);else{try{video.currentTime=to}catch(e){}}}seekRaf=requestAnimationFrame(tick)}
 function firstSeek(l){l=Math.max(1,Math.min(3,l));if(!initial||initial.classList.contains('is-hidden')){seekLevel(l,true);return}if(l===3){active(3);try{video.currentTime=timeFor(3)}catch(e){}return}video.pause();cancelAnimationFrame(seekRaf);var startTime=timeFor(3),done=false;function launch(){if(done)return;done=true;video.removeEventListener('seeked',launch);hideInitial();level=3;seekLevel(l,true,startTime)}video.addEventListener('seeked',launch);try{video.currentTime=startTime}catch(e){launch();return}setTimeout(launch,100)}
 /* Section 21 is click-driven only: no scroll/auto cycling. Initial visual is explicitly the 10° / Level 3 foot state. */
 buttons.forEach(function(b){b.addEventListener('click',function(){firstSeek(+b.dataset.level)})});
 function reset(){cancelAnimationFrame(seekRaf);active(3);showInitial();if(video){video.pause();try{video.currentTime=timeFor(3)}catch(e){}}}
 if(video){video.pause();video.removeAttribute('autoplay');video.loop=false;if(video.readyState>=1)reset();else video.addEventListener('loadedmetadata',reset,{once:true})}else active(3);
 if('IntersectionObserver'in window){var io=new IntersectionObserver(function(es){es.forEach(function(e){if(!e.isIntersecting)reset()})},{threshold:[0,.08]});io.observe(root)}
})();


;
/* ===== Section 22 authoritative Shopify runtime v38.8 ===== */
(()=>{
  const clamp=(v,a=0,b=1)=>Math.max(a,Math.min(b,v));
  const mix=(a,b,t)=>a+(b-a)*t;
  const smooth=t=>{t=clamp(t);return t*t*(3-2*t)};

  function init(){
    const root=document.getElementById('sb22-continuous');
    if(!root)return;
    if(root.dataset.sb22Ready==='shopify-v38-8')return;
    root.dataset.sb22Ready='shopify-v38-8';

    const sticky=root.querySelector('.sb22__sticky');
    const panel=root.querySelector('[data-panel]');
    const track=root.querySelector('.sb22__scenes');
    const kbd=root.querySelector('[data-kbd]');
    const copy=root.querySelector('[data-copy]');
    if(!sticky||!panel||!track||!kbd||!copy)return;

    track.removeAttribute('aria-hidden');
    [sticky,panel,track,kbd,copy].forEach(el=>{
      el.style.setProperty('display','block','important');
      el.style.setProperty('visibility','visible','important');
    });
    kbd.style.setProperty('opacity','1','important');

    // Preserve the authored text in the DOM, but render a viewport-relative copy
    // so short/wide Shopify viewports cannot crop "LONG" or the paragraph.
    let copyViewport=root.querySelector('.sb22__copy-viewport');
    if(!copyViewport){
      copyViewport=document.createElement('div');
      copyViewport.className='sb22__copy-viewport';
      copyViewport.setAttribute('aria-label','Built for Long Sessions');
      copyViewport.innerHTML='<h2><span>BUILT FOR LONG</span><span>SESSIONS</span></h2><p>Every part of EC75 is designed to make long hours feel effortless. A rigid CNC aluminum top delivers a stable, premium feel, while the lightweight PC base keeps the keyboard comfortable to use and easy to move.</p>';
      sticky.appendChild(copyViewport);
    }
    copy.style.setProperty('opacity','0','important');
    copy.style.setProperty('visibility','hidden','important');
    copy.setAttribute('aria-hidden','true');

    const S=[
      {scene:0,x:733.91357421875,y:645.7605285644531,r:0},
      {scene:1,x:733.91357421875,y:645.7605285644531,r:0},
      {scene:2,x:733.91357421875,y:645.7605285644531,r:0},
      {scene:3,x:733.91357421875,y:645.7605285644531,r:0},
      {scene:3,x:690,y:760,r:24},
      {scene:3,x:730,y:980,r:40},
      {scene:3,x:775,y:1250,r:54},
      {scene:3,x:810,y:1700,r:62},
      {scene:3,x:835,y:2110,r:68},
      {scene:3,x:850,y:2270,r:72}
    ];
    const BASE=S[0];
    const reduced=window.matchMedia&&window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function viewportHeight(){return window.innerHeight||document.documentElement.clientHeight||1}
    function camFromState(t){
      const old=t*(9.15/9);
      if(old<5.58)return 0;
      if(old<8.28)return mix(0,1550,smooth((old-5.58)/2.7));
      return mix(1550,1640,smooth((old-8.28)/.87));
    }
    function interp(t){
      t=clamp(t,0,9);
      const i=Math.min(8,Math.floor(t)),u=smooth(t-i),a=S[i],b=S[i+1];
      return {scene:mix(a.scene,b.scene,u),x:mix(a.x,b.x,u),y:mix(a.y,b.y,u),r:mix(a.r,b.r,u)};
    }
    function timeline(p){
      p=clamp(p);
      if(p<=.06)return 0;
      if(p<.22)return smooth((p-.06)/.16);
      if(p<.27)return 1;
      if(p<.43)return 1+smooth((p-.27)/.16);
      if(p<.48)return 2;
      if(p<.64)return 2+smooth((p-.48)/.16);
      if(p<.68)return 3;
      return 3+6*smooth((p-.68)/.32);
    }
    function bounceFromState(t){
      if(t<=7.35)return 0;
      const q=clamp((t-7.35)/1.65);
      return 78*Math.sin(q*Math.PI*3)*(1-q);
    }
    function pinStage(){
      const rect=root.getBoundingClientRect();
      const vh=viewportHeight();
      const maxY=Math.max(0,root.offsetHeight-vh);
      const y=clamp(-rect.top,0,maxY);
      sticky.style.setProperty('position','absolute','important');
      sticky.style.setProperty('top',y.toFixed(2)+'px','important');
      sticky.style.setProperty('left','0','important');
      sticky.style.setProperty('width','100%','important');
      sticky.style.setProperty('height',vh+'px','important');
      sticky.style.setProperty('min-height',vh+'px','important');
      return {rect,vh,maxY};
    }
    function progressNow(measure){
      const m=measure||pinStage();
      return clamp((-m.rect.top)/Math.max(m.maxY,1));
    }
    function render(t){
      const st=interp(t),c=camFromState(t),bounce=bounceFromState(t);
      track.style.setProperty('transform',`translate3d(${(-1000*st.scene).toFixed(3)}px,0,0)`,'important');
      panel.style.setProperty('transform',`translate3d(0,${(-c).toFixed(3)}px,0)`,'important');
      // Keep the original authored copy hidden; the new overlay follows only the
      // intended late camera phase and is never horizontally clipped.
      copy.style.setProperty('opacity','0','important');
      copy.style.setProperty('visibility','hidden','important');
      // v38.8: keep the authored drop/rotation, then settle the keyboard farther
      // up-left on desktop so the final composition matches the reference frame
      // instead of crowding the copy. Offsets are design-canvas units and therefore
      // scale naturally with --u. Mobile keeps the v38.7 path.
      const wide=(window.innerWidth||document.documentElement.clientWidth||0)>900;
      const settle=wide?smooth(clamp((t-6.15)/2.25)):0;
      const layoutDx=mix(0,-455,settle);
      const layoutDy=mix(0,-355,settle);
      kbd.style.setProperty('transform',`translate3d(${(st.x-BASE.x+layoutDx).toFixed(3)}px,${(st.y-BASE.y-c+bounce+layoutDy).toFixed(3)}px,0) rotate(${st.r.toFixed(3)}deg)`,'important');
      kbd.style.setProperty('display','block','important');
      kbd.style.setProperty('visibility','visible','important');
      kbd.style.setProperty('opacity','1','important');

      const cp=smooth(clamp((t-6.15)/1.35));
      copyViewport.style.setProperty('display','block','important');
      copyViewport.style.setProperty('visibility','visible','important');
      copyViewport.style.setProperty('opacity',cp.toFixed(4),'important');
      copyViewport.style.setProperty('transform',`translate3d(0,${mix(64,0,cp).toFixed(2)}px,0)`,'important');
      root.style.setProperty('--sb22-state',t.toFixed(4));
    }

    let target=timeline(progressNow(pinStage()));
    let shown=target;
    let animRaf=0,last=0;
    function animate(now){
      animRaf=0;
      if(reduced){shown=target;render(shown);return}
      const dt=Math.min(64,last?now-last:16);last=now;
      const follow=1-Math.exp(-dt/180);
      shown+=(target-shown)*follow;
      render(shown);
      if(Math.abs(target-shown)>.0008)animRaf=requestAnimationFrame(animate);
      else{shown=target;render(shown);last=0}
    }
    function update(){
      const m=pinStage();
      target=timeline(progressNow(m));
      if(reduced){shown=target;render(shown);return}
      if(!animRaf)animRaf=requestAnimationFrame(animate);
    }

    window.addEventListener('scroll',update,{passive:true});
    window.addEventListener('resize',update,{passive:true});
    window.addEventListener('pageshow',update);
    let p=root.parentElement,seen=new Set();
    while(p&&p!==document.body){
      const cs=getComputedStyle(p);
      if(/auto|scroll|overlay/.test(cs.overflowY||'')&&!seen.has(p)){
        p.addEventListener('scroll',update,{passive:true});
        seen.add(p);
      }
      p=p.parentElement;
    }
    document.addEventListener('shopify:section:load',()=>setTimeout(update,30));
    document.addEventListener('shopify:block:select',update);

    render(shown);
    update();
    setTimeout(update,80);
    setTimeout(update,350);
  }

  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init,{once:true});else init();
  document.addEventListener('shopify:section:load',()=>setTimeout(init,0));
})();

;
/* ===== Section 23 authoritative Shopify runtime v38.12 ===== */
(()=>{
  const clamp=(v,a=0,b=1)=>Math.max(a,Math.min(b,v));
  const ease=t=>{t=clamp(t);return t*t*(3-2*t)};

  const init=(root)=>{
    if(!root)return;
    if(root.dataset.sb23Ready==='shopify-v38-12'){
      window.dispatchEvent(new Event('resize'));
      return;
    }
    root.dataset.sb23Ready='shopify-v38-12';

    const stage=root.querySelector('.sb23__stage');
    const hero=root.querySelector('.sb23__hero-sticky');
    const showcase=root.querySelector('[data-sb23-showcase]');
    const front=showcase&&showcase.querySelector('.sb23__showcase-kbd--front');
    const reduced=window.matchMedia&&window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    root.classList.add('is-photo-fold-ready');

    // Photography stack: keep the authored first lifestyle image pinned while
    // split/detail photos fold upward over it. This remains Shopify-safe and
    // independent from the product front/back lock below.
    const pinHero=()=>{
      if(!stage||!hero||!root.isConnected)return;
      const rect=stage.getBoundingClientRect();
      const stageH=stage.offsetHeight||rect.height||0;
      const heroH=hero.offsetHeight||0;
      const maxY=Math.max(0,stageH-heroH);
      const y=clamp(-rect.top,0,maxY);
      hero.style.setProperty('position','absolute','important');
      hero.style.setProperty('left','0','important');
      hero.style.setProperty('top','0','important');
      hero.style.setProperty('width','100%','important');
      hero.style.setProperty('transform',`translate3d(0,${y.toFixed(2)}px,0)`,'important');
      root.style.setProperty('--sb23-photo-fold-y',y.toFixed(2)+'px');
      root.style.setProperty('--sb23-photo-fold-progress',(maxY?y/maxY:0).toFixed(5));
    };

    // Product front/back sequence: restore the v38/Figma interaction exactly.
    // When the showcase reaches its authored framing, wheel input is consumed,
    // the page stays fixed, and the keyboard cycles front -> back -> front.
    // Only after the cycle is complete does the next wheel input continue down.
    if(showcase&&front){
      showcase.classList.remove('is-reference-motion');
      showcase.classList.add('is-scroll-controlled','is-shopify-safe-motion','is-v38-lock-motion');

      const hiddenAtProgress=(progress)=>{
        const p=clamp(progress,0,1);
        if(p<0.18)return 0;
        if(p<0.43)return 100*ease((p-0.18)/(0.43-0.18));
        if(p<0.64)return 100;
        if(p<0.89)return 100*(1-ease((p-0.64)/(0.89-0.64)));
        return 0;
      };
      const paintFace=(hidden)=>{
        const value=clamp(hidden,0,100);
        front.style.setProperty('clip-path',`inset(0 0 ${value.toFixed(3)}% 0)`,'important');
        showcase.style.setProperty('--sb23-face-progress',(1-value/100).toFixed(4));
        showcase.dataset.sb23Face=value<=.05?'front':value>=99.95?'back':'transition';
      };

      if(reduced){
        paintFace(0);
      }else{
        const normalizedDelta=(event)=>{
          const vh=window.innerHeight||document.documentElement.clientHeight||1;
          if(event.deltaMode===1)return event.deltaY*16;
          if(event.deltaMode===2)return event.deltaY*vh;
          return event.deltaY;
        };

        const WHEEL_DISTANCE=2600;
        let scrub=0;
        let locked=false;
        let direction=1;
        let lockY=0;
        let lastScrollY=window.scrollY||window.pageYOffset||0;
        let bypass='';
        let restoring=false;
        let releaseGraceUntil=0;

        const targetLockY=()=>{
          const rect=showcase.getBoundingClientRect();
          const vh=window.innerHeight||document.documentElement.clientHeight||1;
          const pageY=window.scrollY||window.pageYOffset||0;
          // Same authored framing as v38: the showcase bottom sits near the
          // lower viewport edge while the front/back cycle is scrubbed.
          const targetBottom=vh*0.855;
          return Math.max(0,pageY+rect.bottom-targetBottom);
        };
        const forceLockPosition=()=>{
          if(!locked||!root.isConnected)return;
          const y=window.scrollY||window.pageYOffset||0;
          if(Math.abs(y-lockY)>0.5){
            restoring=true;
            window.scrollTo(0,lockY);
            requestAnimationFrame(()=>{restoring=false;});
          }
        };
        const enterLock=(dir)=>{
          if(locked||!root.isConnected)return;
          direction=dir>=0?1:-1;
          lockY=targetLockY();
          scrub=direction>0?0:1;
          bypass='';
          locked=true;
          showcase.classList.add('is-face-locking');
          paintFace(hiddenAtProgress(scrub));
          restoring=true;
          window.scrollTo(0,lockY);
          requestAnimationFrame(()=>{restoring=false;});
        };
        const releaseLock=()=>{
          locked=false;
          restoring=false;
          showcase.classList.remove('is-face-locking');
          // After one complete visible front -> back -> front cycle, fully hand
          // wheel control back to the document in BOTH directions. Keep a short
          // grace window so the lock cannot immediately re-arm at the same Y.
          bypass='both';
          releaseGraceUntil=(window.performance&&performance.now?performance.now():Date.now())+1400;
          lastScrollY=window.scrollY||window.pageYOffset||0;
        };
        // hiddenAtProgress() is visually back on the front face at p=.89 when
        // moving down, and at p=.18 when moving up. Waiting for 1/0 creates an
        // invisible dead zone that feels like the page is frozen. Unlock at the
        // exact visual completion points instead.
        const completedFor=(dir)=>dir>0?scrub>=0.89:scrub<=0.18;

        const onWheel=(event)=>{
          if(!root.isConnected)return;
          const delta=normalizedDelta(event);
          if(Math.abs(delta)<0.01)return;
          const dir=delta>0?1:-1;

          if(locked){
            event.preventDefault();
            scrub=clamp(scrub+delta/WHEEL_DISTANCE,0,1);
            paintFace(hiddenAtProgress(scrub));
            forceLockPosition();
            if(completedFor(direction))releaseLock();
            return;
          }

          const y=window.scrollY||window.pageYOffset||0;
          const target=targetLockY();
          const near=Math.max(36,Math.min(180,(window.innerHeight||800)*0.16));

          const now=(window.performance&&performance.now?performance.now():Date.now());
          if(bypass==='both'||now<releaseGraceUntil){
            // Do not preventDefault here. Normally the browser scrolls the page.
            // Some Shopify/theme wrappers can still swallow a wheel gesture when
            // the pointer sits over an overflow-clipped showcase, so verify that
            // the document actually moved and provide a native-equivalent fallback.
            const beforeY=window.scrollY||window.pageYOffset||0;
            const passDelta=delta;
            setTimeout(()=>{
              if(locked||!root.isConnected)return;
              const afterY=window.scrollY||window.pageYOffset||0;
              if(Math.abs(afterY-beforeY)<1){
                window.scrollBy({top:passDelta,left:0,behavior:'auto'});
              }
            },32);
            return;
          }

          if(dir>0){
            if(bypass==='down')return;
            if(y>=target-near&&y<=target+near){
              event.preventDefault();
              enterLock(1);
              scrub=clamp(scrub+Math.max(delta,0)/WHEEL_DISTANCE,0,1);
              paintFace(hiddenAtProgress(scrub));
            }
          }else{
            if(bypass==='up')return;
            if(y>=target-near&&y<=target+near){
              event.preventDefault();
              enterLock(-1);
              scrub=clamp(scrub+Math.min(delta,0)/WHEEL_DISTANCE,0,1);
              paintFace(hiddenAtProgress(scrub));
            }
          }
        };

        const onScroll=()=>{
          if(!root.isConnected)return;
          const y=window.scrollY||window.pageYOffset||0;
          if(locked){
            if(!restoring)forceLockPosition();
            lastScrollY=lockY;
            return;
          }
          const target=targetLockY();
          const dir=y>lastScrollY?1:y<lastScrollY?-1:0;

          if(bypass==='both'){
            if(Math.abs(y-target)>120){
              bypass='';
              releaseGraceUntil=0;
            }
          }else if(bypass==='down'){
            if(y>target+80)bypass='';
          }else if(bypass==='up'){
            if(y<target-80)bypass='';
          }

          const now=(window.performance&&performance.now?performance.now():Date.now());
          if(!bypass&&now>=releaseGraceUntil&&dir>0&&lastScrollY<target&&y>=target){
            enterLock(1);
          }else if(!bypass&&now>=releaseGraceUntil&&dir<0&&lastScrollY>target&&y<=target){
            enterLock(-1);
          }
          lastScrollY=locked?lockY:(window.scrollY||window.pageYOffset||0);
        };

        const onResize=()=>{
          pinHero();
          if(locked){lockY=targetLockY();forceLockPosition();}
        };

        window.addEventListener('wheel',onWheel,{passive:false,capture:true});
        window.addEventListener('scroll',onScroll,{passive:true});
        window.addEventListener('resize',onResize,{passive:true});
        window.addEventListener('pageshow',()=>{lastScrollY=window.scrollY||window.pageYOffset||0;pinHero();});
        paintFace(0);
      }
    }

    let raf=0;
    const scheduleHero=()=>{
      if(raf)return;
      raf=requestAnimationFrame(()=>{raf=0;pinHero();});
    };
    window.addEventListener('scroll',scheduleHero,{passive:true});
    window.addEventListener('resize',scheduleHero,{passive:true});
    window.addEventListener('pageshow',scheduleHero);

    let parent=root.parentElement;
    const seen=new Set();
    while(parent&&parent!==document.body){
      const cs=getComputedStyle(parent);
      if(/auto|scroll|overlay/.test((cs.overflowY||'')+' '+(cs.overflow||''))&&!seen.has(parent)){
        parent.addEventListener('scroll',scheduleHero,{passive:true});
        seen.add(parent);
      }
      parent=parent.parentElement;
    }

    document.addEventListener('shopify:section:load',()=>setTimeout(scheduleHero,30));
    document.addEventListener('shopify:block:select',scheduleHero);

    root.querySelectorAll('[data-sb23-item]').forEach(item=>{
      const button=item.querySelector('[data-sb23-toggle]');
      if(!button||button.dataset.sb23Bound==='1')return;
      button.dataset.sb23Bound='1';
      const sync=open=>{
        item.classList.toggle('is-open',open);
        button.setAttribute('aria-expanded',String(open));
      };
      sync(item.classList.contains('is-open'));
      button.addEventListener('click',()=>sync(!item.classList.contains('is-open')));
    });

    pinHero();
    setTimeout(pinHero,80);
    setTimeout(pinHero,350);
    if(document.fonts&&document.fonts.ready)document.fonts.ready.then(pinHero).catch(()=>{});
  };

  const boot=()=>EC75_SCOPE().querySelectorAll('[data-sb23]').forEach(init);
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',boot,{once:true});else boot();
  document.addEventListener('shopify:section:load',boot);
})();

;
/* ===== Original inline script 21 ===== */
(()=>{
 const root=EC75_SCOPE().querySelector('.shadowblade-section4-master.sb4-v27');if(!root)return;
 if(window.matchMedia&&matchMedia('(prefers-reduced-motion: reduce)').matches)return;
 const imgs=[...root.querySelectorAll('.sb4-v27__scene img')];
 let inside=false,timer=0,raf=0;const LINE=.62;
 const reset=()=>{clearTimeout(timer);root.classList.remove('is-animating','is-resolved');void root.offsetWidth};
 const play=()=>{clearTimeout(timer);root.classList.remove('is-animating','is-resolved');void root.offsetWidth;requestAnimationFrame(()=>{root.classList.add('is-animating');timer=setTimeout(()=>{root.classList.remove('is-animating');root.classList.add('is-resolved')},1080)})};
 const evalPos=()=>{const r=root.getBoundingClientRect(),line=(innerHeight||document.documentElement.clientHeight)*LINE,on=r.top<=line&&r.bottom>=line;if(on&&!inside){inside=true;play()}else if(!on&&inside){inside=false;reset()}};
 const schedule=()=>{if(raf)return;raf=requestAnimationFrame(()=>{raf=0;evalPos()})};
 const ready=()=>{root.classList.add('is-motion-ready');inside=false;reset();evalPos()};
 Promise.all(imgs.map(i=>i.decode?i.decode().catch(()=>{}):Promise.resolve())).then(()=>requestAnimationFrame(ready));
 addEventListener('scroll',schedule,{passive:true});addEventListener('resize',schedule,{passive:true});addEventListener('pageshow',()=>{inside=false;reset();schedule()});
 document.addEventListener('shopify:section:load',()=>{inside=false;reset();setTimeout(schedule,50)});
})();


  // Re-measure after portal/font/media layout settles. This is intentionally dispatched after all
  // original section initializers have attached their listeners.
  const EC75_REFRESH_MOTION=()=>{
        EC75_ALIGN_FULL_BLEED();
    requestAnimationFrame(()=>{
      window.dispatchEvent(new Event('resize'));
      window.dispatchEvent(new Event('scroll'));
    });
  };
  window.addEventListener('load',EC75_REFRESH_MOTION,{once:true});
  window.addEventListener('pageshow',EC75_REFRESH_MOTION);
  document.addEventListener('shopify:section:load',()=>setTimeout(EC75_REFRESH_MOTION,30));
  if(document.fonts&&document.fonts.ready)document.fonts.ready.then(EC75_REFRESH_MOTION).catch(()=>{});
  setTimeout(EC75_REFRESH_MOTION,80);
  setTimeout(EC75_REFRESH_MOTION,500);

})();


;/* ===== Section 9 authoritative Shopify runtime v38.5 ===== */
(()=>{
  const clamp=(v,a=0,b=1)=>Math.max(a,Math.min(b,v));
  const norm=(v,a,b)=>clamp((v-a)/(b-a));
  const smooth=t=>{t=clamp(t);return t*t*(3-2*t)};
  const lerp=(a,b,t)=>a+(b-a)*t;

  function releaseStickyAncestors(root){
    // Sticky/fixed descendants can be trapped by a theme ancestor with overflow,
    // transform, contain, filter, perspective or clip-path. Neutralize only the
    // ancestor chain that actually wraps this Custom Liquid instance.
    let p=root.parentElement;
    let hops=0;
    while(p&&p!==document.body&&hops<10){
      p.style.setProperty('overflow','visible','important');
      p.style.setProperty('overflow-x','visible','important');
      p.style.setProperty('overflow-y','visible','important');
      p.style.setProperty('contain','none','important');
      p.style.setProperty('transform','none','important');
      p.style.setProperty('filter','none','important');
      p.style.setProperty('perspective','none','important');
      p.style.setProperty('clip-path','none','important');
      p.style.setProperty('mask','none','important');
      p.style.setProperty('-webkit-mask','none','important');
      p.style.setProperty('will-change','auto','important');
      if(p.tagName==='MAIN')break;
      p=p.parentElement;
      hops++;
    }
  }

  function init(){
    const root=document.getElementById('ShadowbladeSwitchPro-preview');
    if(!root)return;
    const runway=root.querySelector('[data-sb9v9-runway]');
    const pin=root.querySelector('[data-sb9v9-pin]');
    const hero=root.querySelector('.sb9v9__hero-copy');
    const heroP=hero&&hero.querySelector('p');
    const explodeWrap=root.querySelector('.sb9v9__explode');
    const assembled=root.querySelector('.sb9v9__assembled');
    const parts=root.querySelector('.sb9v9__parts');
    const stem=root.querySelector('.sb9v9__part--stem');
    const magnet=root.querySelector('.sb9v9__part--magnet');
    const topPart=root.querySelector('.sb9v9__part--top');
    const spring=root.querySelector('.sb9v9__part--spring');
    const bottom=root.querySelector('.sb9v9__part--bottom');
    const details=root.querySelector('.sb9v9__details');
    const keyboard=root.querySelector('.sb9v9__keyboard');
    const band=root.querySelector('.sb9v9__band');
    const specs=root.querySelector('.sb9v9__specs');
    if(!runway||!pin||!hero||!explodeWrap||!assembled||!parts||!details||!band||!specs)return;

    releaseStickyAncestors(root);

    // These were aria-hidden in the standalone prototype. Some Shopify themes
    // interpret aria-hidden as display:none, which removed the exploded parts and
    // the whole lower specification layer. Empty-alt images remain non-announcing.
    parts.removeAttribute('aria-hidden');
    details.removeAttribute('aria-hidden');
    parts.style.setProperty('display','block','important');
    details.style.setProperty('display','block','important');
    parts.style.setProperty('visibility','visible','important');
    details.style.setProperty('visibility','visible','important');
    specs.style.setProperty('display','grid','important');
    band.style.setProperty('display','block','important');

    root.dataset.sb9Fix='5';
    let raf=0;
    let activeLoop=0;

    function unit(){
      // Mirrors --u:min(.0782472613vw,2.00312989px) from the audited v38.
      return Math.min((window.innerWidth||document.documentElement.clientWidth||1278)*0.000782472613,2.00312989);
    }

    function pinHeight(){
      const u=unit();
      return Math.min(window.innerHeight||document.documentElement.clientHeight||720,720*u);
    }

    function progress(){
      const rr=runway.getBoundingClientRect();
      const ph=pinHeight();
      const distance=Math.max(1,runway.getBoundingClientRect().height-ph);
      return clamp((-rr.top)/distance);
    }

    function placePin(raw){
      const rr=runway.getBoundingClientRect();
      const ph=pinHeight();
      const active=rr.top<=0 && rr.bottom>=ph;
      const passed=rr.bottom<ph;
      pin.classList.toggle('sb9v9-fix5-fixed',active);
      pin.classList.toggle('sb9v9-fix5-before',!active&&!passed);
      pin.classList.toggle('sb9v9-fix5-after',!active&&passed);
      if(active){
        pin.style.setProperty('height',ph+'px','important');
        pin.style.setProperty('min-height',ph+'px','important');
        pin.style.setProperty('max-height',ph+'px','important');
      }
      return active;
    }

    function render(raw){
      const u=unit();
      const scrollExplode=smooth(norm(raw,.30,.58));
      const titleOut=smooth(norm(raw,.36,.56));
      const eyebrowOut=smooth(norm(raw,.48,.66));
      const after=smooth(norm(raw,.64,.97));
      const explosionExit=smooth(norm(raw,.66,.86));
      const bandY=lerp(590,92,after);
      const lowerOpacity=smooth(norm(raw,.72,.88));
      const partsOpacity=clamp(scrollExplode*5);

      // Keep the legacy CSS variables updated for any surviving audited rules.
      root.style.setProperty('--raw',raw.toFixed(4));
      root.style.setProperty('--explode',scrollExplode.toFixed(4));
      root.style.setProperty('--parts-opacity',partsOpacity.toFixed(4));
      root.style.setProperty('--band-y',bandY.toFixed(2));
      root.style.setProperty('--lower-opacity',lowerOpacity.toFixed(4));
      root.style.setProperty('--explode-shift',(-570*explosionExit).toFixed(2));
      root.style.setProperty('--title-shift',(-205*titleOut).toFixed(2));
      root.style.setProperty('--title-opacity',(1-titleOut).toFixed(4));
      root.style.setProperty('--eyebrow-shift',(-80*eyebrowOut).toFixed(2));
      root.style.setProperty('--eyebrow-opacity',(1-eyebrowOut).toFixed(4));

      // Authoritative inline transforms avoid theme rules and avoid CSS calc()
      // multiplication compatibility differences.
      hero.style.setProperty('transform',`translate(-50%,${(-205*titleOut*u).toFixed(2)}px)`,'important');
      hero.style.setProperty('opacity',(1-titleOut).toFixed(4),'important');
      if(heroP){
        heroP.style.setProperty('transform',`translateY(${(-80*eyebrowOut*u).toFixed(2)}px)`,'important');
        heroP.style.setProperty('opacity',(1-eyebrowOut).toFixed(4),'important');
      }

      explodeWrap.style.setProperty('transform',`translate(-50%,${(-570*explosionExit*u).toFixed(2)}px)`,'important');
      assembled.style.setProperty('transform',`translate(-50%,-47%) scale(${(1-scrollExplode*.05).toFixed(5)})`,'important');
      assembled.style.setProperty('opacity',(1-partsOpacity).toFixed(4),'important');
      parts.style.setProperty('opacity',partsOpacity.toFixed(4),'important');

      if(stem)stem.style.setProperty('transform',`translate(-50%,calc(-50% - ${(scrollExplode*118*u).toFixed(2)}px)) rotate(${(-scrollExplode).toFixed(3)}deg)`,'important');
      if(magnet)magnet.style.setProperty('transform',`translate(-50%,calc(-50% - ${(scrollExplode*55*u).toFixed(2)}px))`,'important');
      if(topPart)topPart.style.setProperty('transform',`translate(-50%,calc(-50% + ${(scrollExplode*22*u).toFixed(2)}px))`,'important');
      if(spring)spring.style.setProperty('transform',`translate(-50%,calc(-50% + ${(scrollExplode*115*u).toFixed(2)}px))`,'important');
      if(bottom)bottom.style.setProperty('transform',`translate(-50%,calc(-50% + ${(scrollExplode*213*u).toFixed(2)}px))`,'important');

      band.style.setProperty('transform',`translateY(${(bandY*u).toFixed(2)}px)`,'important');
      band.style.setProperty('visibility','visible','important');
      if(keyboard){
        keyboard.style.setProperty('opacity',lowerOpacity.toFixed(4),'important');
        keyboard.style.setProperty('visibility','visible','important');
        keyboard.style.setProperty('display','block','important');
      }
      specs.style.setProperty('opacity',lowerOpacity.toFixed(4),'important');
      specs.style.setProperty('visibility','visible','important');
    }

    function update(){
      raf=0;
      const raw=progress();
      const active=placePin(raw);
      render(raw);
      const rr=root.getBoundingClientRect();
      const near=rr.bottom>-200 && rr.top<(window.innerHeight||900)+200;
      if(near && !activeLoop){
        activeLoop=requestAnimationFrame(loop);
      }
    }

    function loop(){
      activeLoop=0;
      const rr=root.getBoundingClientRect();
      const vh=window.innerHeight||document.documentElement.clientHeight||900;
      if(rr.bottom<-250 || rr.top>vh+250)return;
      const raw=progress();
      placePin(raw);
      render(raw);
      activeLoop=requestAnimationFrame(loop);
    }

    function schedule(){if(!raf)raf=requestAnimationFrame(update)}

    // Listen to window and any theme-specific scrolling ancestors.
    window.addEventListener('scroll',schedule,{passive:true});
    window.addEventListener('resize',()=>{releaseStickyAncestors(root);schedule()},{passive:true});
    let p=root.parentElement,seen=new Set();
    while(p&&p!==document.body){
      const cs=getComputedStyle(p);
      if(/auto|scroll|overlay/.test(cs.overflowY||'') && !seen.has(p)){
        p.addEventListener('scroll',schedule,{passive:true});seen.add(p);
      }
      p=p.parentElement;
    }
    document.addEventListener('shopify:section:load',()=>setTimeout(()=>{releaseStickyAncestors(root);schedule()},30));
    document.addEventListener('shopify:block:select',schedule);
    window.addEventListener('pageshow',schedule);
    requestAnimationFrame(update);
    setTimeout(schedule,80);
    setTimeout(schedule,350);
  }

  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init,{once:true});else init();
  document.addEventListener('shopify:section:load',()=>setTimeout(init,0));
})();
